export const ChevronDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
    <path d="M0.999786 1.49992L5.99983 6.49988L10.9998 1.49988" stroke="#616675" strokeWidth="1.5" strokeMiterlimit="16" />
  </svg>
);
